<template>
  <div class="h5-page">
    <div class="h5-header">我的订单</div>
    <div class="status-bar">
      <span
        v-for="(name, status) in statusMap"
        :key="status"
        class="status-tag"
        :class="{ on: queryStatus === status }"
        @click="switchStatus(status)">{{ name }}</span>
    </div>
    <div class="h5-body">
      <div v-for="order in orders" :key="order.id" class="h5-card" @click="goDetail(order)">
        <div class="order-row">
          <span class="order-no">{{ order.billNo }}</span>
          <span class="order-status" :style="{ color: statusColor[order.orderStatus] }">{{ order.orderStatusName || statusMap[order.orderStatus] }}</span>
        </div>
        <div class="order-row sub">
          <span>伙伴：{{ order.partnerName || '-' }}</span>
          <span>{{ order.subType === '采购订单' ? '采购' : '销售' }} · {{ sourceMap[order.sourceType] || order.sourceType }}</span>
        </div>
        <div class="order-row sub">
          <span>金额：￥{{ formatAmount(order.totalPrice) }}</span>
          <span>{{ order.operTime }}</span>
        </div>
      </div>
      <div v-if="!loading && orders.length === 0" class="empty">暂无订单</div>
      <a-button v-if="hasMore && !loading" block @click="loadOrders">加载更多</a-button>
    </div>
    <h5-tab-bar active="orders" />
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getH5Orders } from '@/api/plugin/orderReceive'
import H5TabBar from './H5TabBar'
import './h5-common.css'

export default {
  name: 'H5Orders',
  components: { H5TabBar },
  data() {
    return {
      loading: false,
      orders: [],
      page: 1,
      total: 0,
      queryStatus: '',
      statusMap: {
        '20': '已接单',
        '30': '备货中',
        '40': '已出库',
        '50': '配送中',
        '60': '已送达',
        '70': '已入库',
        '80': '已付款'
      },
      statusColor: {
        '20': '#13c2c2',
        '30': '#1890ff',
        '40': '#722ed1',
        '50': '#2f54eb',
        '60': '#52c41a',
        '70': '#a0d911',
        '80': '#faad14'
      },
      sourceMap: { qgd: '请购', img: '发图', manual: '手动' }
    }
  },
  computed: {
    hasMore() {
      return this.orders.length < this.total
    }
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.$router.replace('/h5/login')
      return
    }
    this.loadOrders()
  },
  methods: {
    loadOrders() {
      this.loading = true
      getH5Orders({
        currentPage: this.page,
        pageSize: 10,
        orderStatus: this.queryStatus || undefined
      }).then(res => {
        if (res.success) {
          const rows = (res.data && res.data.rows) || []
          this.orders = this.page === 1 ? rows : this.orders.concat(rows)
          this.total = (res.data && res.data.total) || 0
          this.page += 1
        } else if (res.code === 401) {
          this.$router.replace('/h5/login')
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    switchStatus(status) {
      this.queryStatus = this.queryStatus === status ? '' : status
      this.page = 1
      this.loadOrders()
    },
    goDetail(order) {
      this.$router.push('/h5/orders/' + order.headId)
    },
    formatAmount(value) {
      const num = Number(value)
      return isNaN(num) ? '0.00' : Math.abs(num).toFixed(2)
    }
  }
}
</script>
<style scoped>
.status-bar {
  display: flex;
  overflow-x: auto;
  background: #fff;
  padding: 10px 12px;
  gap: 8px;
  position: sticky;
  top: 52px;
  z-index: 98;
  border-bottom: 1px solid #f0f0f0;
}
.status-tag {
  flex-shrink: 0;
  padding: 3px 12px;
  border-radius: 12px;
  background: #f5f5f5;
  color: #666;
  font-size: 13px;
}
.status-tag.on {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}
.order-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.order-row.sub {
  color: #888;
  font-size: 13px;
}
.order-no {
  font-weight: 600;
}
.order-status {
  font-size: 13px;
}
.empty {
  text-align: center;
  color: #999;
  padding: 40px 0;
}
</style>
